<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="مصادر-القصة">
<h1><span dir="rtl">مصادر القصة</span></h1>
<p><span dir="rtl">- كتاب الروضتين في أخبار الدولتين النورية والصلاحية، المؤلف: أبو القاسم شهاب الدين عبد الرحمن بن إسماعيل بن</span> <span dir="rtl">إبراهيم المقدسي الدمشقي المعروف بأبي شامة</span> <span dir="rtl">المتوفَّى</span> 665 <span dir="rtl">هـ (المحقق: إبراهيم الزيبق، الناشر: مؤسسة الرسالة</span> – <span dir="rtl">بيروت، الطبعة الأولى،</span> 1418 <span dir="rtl">هـ</span> 1997 <span dir="rtl">م، عدد الأجزاء: 5.</span></p>
<p>- <span dir="rtl">كتاب البداية والنهاية، المؤلف: أبو الفداء إسماعيل بن عمر بن كثير القرشي البصري ثمَّ الدمشقي (المتوفّى: 774 هـ)، الناشر: دار الفكر، عام النشر</span>1407 <span dir="rtl">هـ 1986م، عدد الأجزاء: 15.</span></p>
<p><span dir="rtl">- كتاب الدر الثمين في سيرة نور الدين - ابن قاضي شهبة.</span></p>
<p><span dir="rtl">- كتاب وفاء الوفاء بأخبار دار المصطفى، المؤلف: علي بن عبد الله بن أحمد الحسني الشافعي، نور الدين أبو الحسن السمهودي المتوفّى: 911ه، الناشر: دار الكتب العلمية</span> - <span dir="rtl">بيروت، الطبعة الأولى</span> <span dir="rtl">1419ه،</span> <span dir="rtl">عدد الأجزاء: 4.</span></p>
<p><span dir="rtl">- كتاب شذرات الذهب في أخبار مِن ذهب، المؤلف: عبد الحي بن أحمد بن محمد بن العماد العَكري الحنبلي، أبو الفلاح، (المتوفَّى: 1089ه)، حقَّقه: محمود الأرناؤوط، خرَّج أحاديثه: عبد القادر الأرناؤوط، الناشر: دار ابن كثير- دمشق</span> – <span dir="rtl">بيروت، الطبعة الأولى</span> 1406 <span dir="rtl">هـ 1986م، عدد الأجزاء: 11.</span></p>
<p><span dir="rtl">- كتاب نزهة الناظرين في مسجد سيِّد الأوَّلين والآخِرين، لجعفر بن إسماعيل البرزنجي، الناشر: دار الكتب العلمية 01/01/1991.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?519c188c